import {
  and,
  asc,
  chat_message,
  chat_thread,
  desc,
  eq,
  or,
  type PowerSyncDrizzleDB,
} from "@famidex/powersync";
import { canonicalPair } from "./pair";

/**
 * 💬 CHAT/DM — lecturas local-first [L]. Los streams `chat_threads` /
 * `chat_messages` sólo entregan hilos/mensajes donde el usuario participa
 * (sender/recipient), así que un tercero jamás ve el hilo A↔B (privacidad DM).
 */

/** Bandeja: hilos donde participo, el más reciente primero. */
export function getThreadsQuery(db: PowerSyncDrizzleDB, userId: string) {
  return db
    .select()
    .from(chat_thread)
    .where(or(eq(chat_thread.user_a, userId), eq(chat_thread.user_b, userId)))
    .orderBy(desc(chat_thread.last_message_at), desc(chat_thread.updated_at));
}

/** Un hilo por id (keyed, para la cabecera de la conversación). */
export function getThreadByIdQuery(db: PowerSyncDrizzleDB, threadId: string) {
  return db.select().from(chat_thread).where(eq(chat_thread.id, threadId)).limit(1);
}

/** Hilo existente entre dos usuarios (par canónico) — dedup del "abrir chat". */
export function getThreadByPairQuery(db: PowerSyncDrizzleDB, a: string, b: string) {
  const [ua, ub] = canonicalPair(a, b);
  return db
    .select()
    .from(chat_thread)
    .where(and(eq(chat_thread.user_a, ua), eq(chat_thread.user_b, ub)))
    .limit(1);
}

/** Mensajes de un hilo en orden cronológico (conversación). */
export function getMessagesQuery(db: PowerSyncDrizzleDB, threadId: string) {
  return db
    .select()
    .from(chat_message)
    .where(eq(chat_message.thread_id, threadId))
    .orderBy(asc(chat_message.created_at));
}
